import { useTranslation } from 'react-i18next'
import DashboardTabLayout from '@/components/dashboard/DashboardTabLayout'

export default function OfferingsHub() {
  const { t } = useTranslation('dashboard')

  return (
    <DashboardTabLayout
      title={t('hubs.offerings.title')}
      subtitle={t('hubs.offerings.subtitle')}
      tabs={[
        {
          id: 'services',
          label: t('hubs.offerings.tabs.services'),
          to: '/dashboard/offerings/services',
        },
        {
          id: 'materials',
          label: t('hubs.offerings.tabs.materials'),
          to: '/dashboard/offerings/materials',
        },
      ]}
    />
  )
}
